export default {
  "pages.layouts.userLayout.title": "Project Management",
  "pages.login.pageTitle": "Sign in / Sign up",
  "pages.login.success": "Signed in",
  "pages.login.failure": "Sign in failed, please try again",
  "pages.login.email.placeholder": "Email",
  "pages.login.email.required": "Please enter your email",
  "pages.login.email.invalid": "Please enter a valid email address",
  "pages.login.brandPitch":
    "Projects, tasks and progress — managed together, for your team.",
  "pages.login.heroTitle": "See every project.\nStop delays early.",
  "pages.login.heroSubtitle":
    "Track progress at a glance with Gantt & WBS. Risks — overdue, blocked, due soon — surface before they bite, keeping the whole team aligned.",
  "pages.login.slogan.1": "Gantt charts, the big picture.",
  "pages.login.slogan.2": "Break work down with WBS.",
  "pages.login.slogan.3": "Catch risks before they slip.",
  "pages.login.slogan.4": "Dependencies and progress, at a glance.",
  "pages.login.line": "Continue with LINE",
  "pages.login.google": "Continue with Google",
  "pages.login.or": "or",
  "pages.login.socialComingSoon": "{provider} login is coming soon",
  "pages.login.privacy":
    "By continuing, you agree to our <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>.",
  "pages.login.openMailbox.gmail": "Open Gmail ↗",
  "pages.login.openMailbox.yahooJp": "Open Yahoo! Mail ↗",
  "pages.login.openMailbox.yahoo": "Open Yahoo Mail ↗",
  "pages.login.openMailbox.icloud": "Open iCloud Mail ↗",
  "pages.login.openMailbox.outlook": "Open Outlook ↗",
  "pages.login.code.send": "Continue with email",
  "pages.login.code.placeholder": "6-digit verification code",
  "pages.login.code.required": "Please enter the verification code",
  "pages.login.code.invalid": "Please enter 6 digits",
  "pages.login.code.sent": "Verification code sent",
  "pages.login.code.sentTo": "Enter the verification code we sent to {email}",
  "pages.login.code.sendFailed": "Failed to send verification code",
  "pages.login.code.resendIn": "Resend available in {seconds}s",
  "pages.login.code.resend": "Resend code",
  "pages.login.continue": "Continue",
  "pages.login.changeEmail": "← Change email",
  "pages.login.method.email": "Email",
  "pages.login.method.password": "Account & Password",
  "pages.login.username.placeholder": "Username or email",
  "pages.login.username.required": "Please enter your username or email",
  "pages.login.password.placeholder": "Password",
  "pages.login.password.required": "Please enter your password",
  "pages.login.password.submit": "Sign in",
  "pages.404.subTitle": "Sorry, the page you visited does not exist",
  "pages.404.buttonText": "Back to Home",
  "pages.502.title": "Cannot reach the server",
  "pages.502.subTitle":
    "The server is not responding right now. Please try again in a moment.",
  "pages.502.buttonText": "Reload",
  "pages.oauth.title": "Signing in…",
  "pages.oauth.processing": "Signing in…",
  "pages.oauth.success": "Signed in",
  "pages.oauth.fetchUserFailed": "Failed to load user info",
  "pages.oauth.backToLogin": "Back to login",
  "pages.oauth.error.stateMismatch":
    "Invalid authentication state. Please try again.",
  "pages.oauth.error.googleFailed": "Google sign-in failed. Please try again.",
  "pages.oauth.error.disabled": "This account has been disabled.",
  "pages.oauth.error.closing":
    "This account is being closed. Contact support to restore it.",
  "pages.oauth.error.generic": "Sign-in failed. Please try again later.",

  // Common
  "common.action": "Action",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.save": "Save",
  "common.created": "Created successfully",
  "common.updated": "Updated successfully",
  "common.deleted": "Deleted successfully",
  "common.createdAt": "Created At",
  "common.reset": "Reset",
  "common.export": "Export",
  "common.exporting": "Exporting...",
  "common.export.success": "Export successful",
  "common.export.noData": "No data to export",
  "common.import": "Import",
  "common.upload": "Click to Upload",

  // Settings
  "notifications.title": "Notifications",
  "settings.tab.account": "Account",
  "settings.tab.security": "Security",
  "settings.account.info": "Account Info",
  "settings.account.username": "Username",
  "settings.account.tenant": "Tenant ID",
  "settings.account.userCode": "User ID",
  "settings.account.createdAt": "Registered",
  "settings.account.displayName": "Display Name",
  "settings.account.displayNamePlaceholder": "Enter a display name",
  "settings.account.displayNameHint":
    "When set, it is shown instead of your account",
  "settings.account.save": "Save",
  "settings.account.displayNameSuccess": "Display name updated",
  "settings.password.title": "Change Password",
  "settings.password.setTitle": "Set Password",
  "settings.password.setHint":
    "Your account signs in with email / Google and has no password yet. Set one to also sign in with email + password. No current password needed — just an email verification code.",
  "settings.password.setSubmit": "Set Password",
  "settings.password.changeDesc":
    "Change your password with an email verification code — no current password needed.",
  "settings.password.setSuccess":
    "Password set. You can now sign in with email + password.",
  "settings.password.old": "Current Password",
  "settings.password.new": "New Password",
  "settings.password.confirm": "Confirm New Password",
  "settings.password.minLength": "Password must be at least 6 characters",
  "settings.password.mismatch": "Passwords do not match",
  "settings.password.submit": "Change Password",
  "settings.password.success": "Password changed successfully",
  "settings.password.code": "Verification code",
  "settings.password.codePlaceholder": "6-digit code",
  "settings.password.sendCode": "Send code",
  "settings.password.codeResendIn": "Resend in {seconds}s",
  "settings.password.codeSent": "Verification code sent",
  "settings.password.codeSentTo": "A code will be sent to {email}",
  "settings.password.codeInvalid": "Please enter a 6-digit code",
  "settings.tab.app": "App Settings",
  "settings.app.title": "App Customization",
  "settings.app.icon": "App Icon",
  "settings.app.icon.desc":
    "Upload a custom icon for your mobile app. Recommended: 1024×1024 px PNG image.",
  "settings.app.icon.upload": "Upload Icon",
  "settings.app.icon.change": "Change Icon",
  "settings.app.icon.delete": "Delete Icon",
  "settings.app.icon.deleteConfirm":
    "Are you sure you want to delete the current icon?",
  "settings.app.icon.requirement":
    "PNG format, square, min 512×512 px recommended",
  "settings.app.icon.success": "Icon updated successfully",
  "settings.app.icon.deleteSuccess": "Icon deleted",
  "settings.app.icon.sizeError":
    "Image must be square and at least 512×512 pixels",

  // --- Logout ---
  "settings.account.logout": "Log Out",
  "settings.account.logoutDesc":
    "Sign out of your account. You'll need to log in again next time.",
  "settings.account.logoutConfirmTitle": "Log out?",

  // --- Account Deletion ---
  "settings.account.dangerZone": "Danger Zone",
  "settings.account.deleteAccount": "Delete Account",
  "settings.account.deleteAccountDesc":
    "After deletion, your account will be permanently removed after 30 days. You can restore it anytime during this period by logging in.",
  "settings.account.deleteConfirmTitle": "Confirm Account Deletion?",
  "settings.account.deleteConfirmDesc":
    "Enter your password to confirm. After deletion you will be logged out. You can restore within 30 days by logging in.",
  "settings.account.deleteConfirmPassword": "Enter password",
  "settings.account.deleteConfirmEmailDesc":
    "Enter your account email {email} to confirm. After deletion you will be logged out. You can restore within 30 days by logging in.",
  "settings.account.deleteConfirmEmailRequired":
    "Please enter your account email",
  "settings.account.deleteConfirmEmailMismatch":
    "Email does not match your account",
  "settings.account.deleteDataNotice":
    "After 30 days, the following data will be permanently erased and cannot be recovered",
  "settings.account.deleteDataItem.records": "Inbound / outbound records",
  "settings.account.deleteDataItem.products": "Products",
  "settings.account.deleteDataItem.user": "Account information",
  "settings.account.deleteSuccess": "Account deletion request submitted",

  // Notices
  "notice.tab.system": "Notifications",
  "notice.tab.todo": "To-Do",
  "notice.empty": "No notifications",
  "notice.todo.empty": "No to-do items",
  "notice.readAll": "Mark all as read",
  "notice.markSelectedRead": "Mark as read",
  "notice.selected": "{count} selected",
  "notice.viewAll": "View All",

  "notice.col.content": "Content",
  "notice.col.time": "Received",
  "notice.col.type": "Type",
  "notice.type.notice": "Notice",
  "notice.type.announcement": "Announcement",
  "notice.detail.title": "Notification Detail",
  "notice.pagination.total": "{total} total",

  // Team invitations
  "invitation.inbox.title": "Pending invitations",
  "invitation.inbox.line": '{inviter} invited you to join the "{team}" team',
  "invitation.inbox.expiresAt": "Expires {date}",
  "invitation.accept": "Accept",
  "invitation.decline": "Decline",
  "invitation.declineConfirm": "Decline this invitation?",
  "invitation.acceptSuccess":
    'Joined "{team}". Switch teams from the top-right.',
  // Invitation email deep-link accept page
  "invitation.accept.pageTitle": "Team invitation",
  "invitation.accept.loading": "Checking the invitation…",
  "invitation.accept.invalidTitle": "Invalid invitation link",
  "invitation.accept.invalidDesc":
    "The link is incorrect or no longer valid. Ask the inviter to resend it.",
  "invitation.accept.expiredTitle": "Invitation expired",
  "invitation.accept.expiredDesc":
    "This invitation has expired. Ask the inviter to resend it.",
  "invitation.accept.acceptedTitle": "Already accepted",
  "invitation.accept.acceptedDesc":
    "This invitation has already been accepted.",
  "invitation.accept.closedTitle": "This invitation is closed",
  "invitation.accept.declinedDesc": "This invitation was declined.",
  "invitation.accept.revokedDesc": "This invitation was revoked.",
  "invitation.accept.loginToAccept": "Sign in to join",
  "invitation.accept.later": "Later",
  "invitation.accept.mismatchDesc":
    "This invitation was sent to {invited}, which differs from your current account ({current}). Please sign in with the invited email.",
  "invitation.accept.switchAccount": "Sign in with another account",
  "invitation.accept.goApp": "Go to the app",

  // Settings - Notices

  // Settings - Team Management
  "settings.tab.team": "Team",
  "settings.tab.holidays": "Holidays",
  "settings.tab.workday": "Work Hours",
  "settings.tab.mcp": "MCP",
  // Work-hours-per-day settings tab
  "pages.workday.title": "Work Hours per Day",
  "pages.workday.desc":
    "The unit used to convert duration between days and hours: how many hours make one workday (default 8h). Adapts to teams/projects that count 8h, 7.5h, etc.",
  "pages.workday.label": "1 workday =",
  "pages.workday.unit": "h",
  "pages.workday.save": "Save",
  "pages.workday.saved": "Work-hours setting saved",
  "pages.workday.range": "Please enter a value between 1 and 24",
  "pages.workday.teamHint":
    "This setting applies to duration display across the whole workspace.",
  "pages.workday.ownerOnly": "Only the owner can change this setting.",
  "pages.workday.note":
    "Existing task inputs (days/hours) are not changed — only how totals are interpreted in hours.",
  "settings.mcp.title": "AI Assistant Connection (MCP)",
  "settings.mcp.intro":
    "Add this URL to your ChatGPT / Claude, then just chat to work with this PM system (view, create, update tasks).",
  "settings.mcp.urlLabel": "Your personal connection URL",
  "settings.mcp.warning":
    'This URL is your personal key. Do not share it. If leaked, use "Regenerate URL" to revoke it.',
  "settings.mcp.regenerate": "Regenerate URL",
  "settings.mcp.regenerateConfirm":
    "Regenerating will immediately invalidate the current URL. Continue?",
  "settings.mcp.regenerated": "A new URL has been issued",
  "settings.mcp.setupTitle": "How to set up",
  "settings.mcp.claudeTitle": "Add in Claude",
  "settings.mcp.chatgptTitle": "Add in ChatGPT",
  "settings.mcp.cl1": 'Settings → Connectors (NOT "Developer / Local MCP")',
  "settings.mcp.cl2": '"Add custom connector" → paste the URL above',
  "settings.mcp.cl3": 'Enable "PM Assistant" in the chat and start talking',
  "settings.mcp.cg1":
    'Settings → Connectors → Advanced → turn on "Developer mode"',
  "settings.mcp.cg2":
    '"Add custom connector" → paste the URL above (Auth: none)',
  "settings.mcp.cg3": 'Pick "PM Assistant" in the chat and start talking',
  "settings.mcp.example":
    'e.g. "Show overdue tasks in project X", "Break this requirement into tasks and register them"',
  "team.name.title": "Workspace Name",
  "team.name.desc":
    "Your workspace name is your tenant name, shown in the team switcher and elsewhere. Only the owner can change it.",
  "team.name.edit": "Edit",
  "team.name.placeholder": "Enter workspace name",
  "team.name.required": "Workspace name is required",
  "team.name.success": "Workspace name updated",
  "team.group.title": "Teams",
  "team.group.desc":
    "Create multiple teams in your workspace and choose which team to invite members to (PRO plan). Members only see projects of their teams.",
  "team.group.create": "New team",
  "team.group.editTitle": "Edit team",
  "team.group.col.name": "Team name",
  "team.group.col.members": "Members",
  "team.group.default": "Default",
  "team.group.members": "Members",
  "team.group.membersTitle": 'Members of "{name}"',
  "team.group.membersDesc":
    "Select members of this team; a member can belong to multiple teams.",
  "team.group.membersPlaceholder": "Select members",
  "team.group.deleteConfirm":
    'Delete team "{name}"? (Move or delete its projects first.)',
  "team.group.nameRequired": "Please enter a team name",
  "team.invite.teams": "Join teams",
  "team.invite.teams.tip":
    "The invitee joins the selected teams upon accepting (multiple allowed).",
  "team.invite.teamsRequired": "Please select at least one team",
  "team.invite.teamsPlaceholder": "Select teams",
  "team.title": "Team Members",
  "team.invite": "Invite",
  "team.invite.title": "Invite a member",
  "team.invite.email": "Email",
  "team.invite.emailInvalid": "Please enter a valid email",
  "team.invite.displayName": "Display name (optional)",
  "team.invite.displayName.tip": "Used as the default name once they accept",
  "team.invite.message": "Message (optional)",
  "team.invite.checking": "Checking email…",
  "team.invite.alreadyMember": "This email is already a member of this team",
  "team.invite.alreadyPending":
    "This email already has a pending invitation. You can resend it.",
  "team.invite.accountExists":
    "This email is registered with the Project Management System. They will join as a member after accepting.",
  "team.invite.accountNew":
    "They will sign up with this email and join the team",
  "team.invite.success": "Invitation sent",
  "team.invite.resend": "Resend",
  "team.invite.resendSuccess": "Invitation resent",
  "team.invite.revoke": "Revoke",
  "team.invite.revokeConfirm": "Revoke this invitation?",
  "team.invite.col.email": "Email",
  "team.invite.col.expiresAt": "Expires",
  "team.invite.col.createdAt": "Sent",
  "team.invitations.title": "Pending invitations",
  "teamSwitcher.title": "Switch team",
  "lang.ja-JP": "Japanese",
  "lang.en-US": "English",
  "lang.zh-CN": "Simplified Chinese",
  "lang.zh-TW": "Traditional Chinese",
  "teamSwitcher.switched": 'Switched to "{team}"',
  "team.col.displayName": "Display Name",
  "team.col.username": "Username",
  "team.col.role": "Role",
  "team.col.teams": "Teams",
  "team.allTeams": "All teams",
  "team.col.status": "Status",
  "team.role.owner": "Primary",
  "team.role.member": "Member",
  "team.status.active": "Active",
  "team.status.disabled": "Disabled",
  "team.status.invited": "Invited",
  "team.edit": "Edit",
  "team.edit.success": "Member info updated",
  "team.remove": "Remove",
  "team.remove.confirm":
    "Remove this member? They will no longer be able to log in.",
  "team.disable": "Disable",
  "team.enable": "Enable",
  "team.permissions": "Permissions",
  "team.permissions.title": "Edit Permissions - {name}",
  "team.permissions.selectAll": "Select All",
  "team.permissions.resetDefaults": "Reset to Defaults",
  "team.permissions.resetDefaults.confirm": "Reset to default permissions?",
  "team.permissions.save.success": "Permissions saved",
  "team.permissions.reset.success": "Permissions reset to defaults",
  "team.permissions.custom": "Custom",
  "team.permissions.default": "Default",
  "team.permissions.col.category": "Category",
  "team.permissions.col.target": "Target",
  "team.permissions.col.permissions": "Permissions",
  "team.permissions.group.product": "Products",
  "team.permissions.group.contact": "Contacts",
  "team.permissions.group.expense": "Expenses",
  "team.permissions.group.income": "Income",
  "team.permissions.group.analytics": "Analytics",
  "team.permissions.action.list": "View",
  "team.permissions.action.add": "Add",
  "team.permissions.action.edit": "Edit",
  "team.permissions.action.delete": "Delete",
  "team.permissions.action.void": "Void",
  "team.permissions.action.export": "Export",
  "team.permissions.action.view": "View",
  "team.permissions.action.category": "Categories",

  // First Login Password Change
  "changeInitialPassword.title": "Change Initial Password",
  "changeInitialPassword.hint":
    "For account security, please change your initial password",
  "changeInitialPassword.new": "New Password",
  "changeInitialPassword.confirm": "Confirm New Password",
  "changeInitialPassword.submit": "Change Password",
  "changeInitialPassword.skip": "Skip for now",
  "changeInitialPassword.success": "Password changed successfully",

  // PM Overview
  "overview.title": "Overview",
  "overview.subtitle": "Spot delays and risks across all projects at a glance",
  "overview.view.all": "All projects",
  "overview.view.member": "My tasks",
  "overview.notMember":
    "Your account is not a PM member yet, so My tasks is unavailable",
  "overview.kpi.activeProjects": "Active projects",
  "overview.kpi.delayedProjects": "Delayed projects",
  "overview.kpi.delayedTasks": "Delayed tasks",
  "overview.kpi.blocked": "Blocked",
  "overview.kpi.dueSoon": "Due this week",
  "overview.kpi.unassigned": "Unassigned",
  "overview.stat.title": "Task summary",
  "overview.stat.inProgress": "In progress",
  "overview.stat.delayed": "Delayed",
  "overview.stat.delayed.tip": "Click to show delayed tasks only",
  "overview.stat.thisWeek": "This week",
  "overview.risk.title": "Risks",
  "overview.risk.clearFilter": "Clear filter",
  "overview.risk.filter.delayed": "Delayed only",
  "overview.risk.empty": "No delays or risks 🎉",
  "overview.risk.col.kind": "Risk",
  "overview.risk.col.project": "Customer / Project",
  "overview.risk.col.task": "Task",
  "overview.risk.col.taskProject": "Task / Customer · Project",
  "overview.risk.col.assignee": "Assignee",
  "overview.risk.col.due": "Due",
  "overview.risk.col.delay": "Delay",
  "overview.risk.col.progress": "Progress",
  "overview.kind.overdue": "Overdue",
  "overview.kind.behind": "Behind",
  "overview.kind.blocked": "Blocked",
  "overview.kind.due-soon": "Due soon",
  "overview.kind.unassigned": "Unassigned",
  "overview.delay.overdueDays": "{n}d overdue",
  "overview.delay.dueInDays": "{n}d left",
  "overview.delay.today": "Today",
  "overview.unassignedLabel": "Unassigned",
  "overview.health.title": "Project health",
  "overview.health.empty": "No projects",
  "overview.health.delayBadge": "Delay {n}",
  "overview.assignee.title": "Tasks by assignee",
  "overview.assignee.empty": "No assigned tasks",
  "overview.assignee.unassigned": "Unassigned",
  "overview.assignee.tasksUnit": "{n} tasks",
  "overview.milestone.title": "Milestones this week",
  "overview.milestone.empty": "No upcoming milestones",
  "overview.milestone.overdue": "{n}d overdue",
  "overview.milestone.dueIn": "{n}d left",
  "overview.my.kpi.open": "My open tasks",
  "overview.my.kpi.delayed": "Overdue",
  "overview.my.kpi.thisWeek": "Due this week",
  "overview.my.kpi.bugs": "My open bugs",
  "overview.my.kpi.bugsHigh": "High {n}",
  "overview.my.count": "{n} open",
  "overview.my.countShort": "{n}",
  "overview.my.noDue": "No due date",
  "overview.my.tasks.title": "My tasks",
  "overview.my.tasks.hint": "Click a row to open the Gantt",
  "overview.my.tasks.empty": "No open tasks assigned to you 🎉",
  "overview.my.bucket.overdue": "Overdue",
  "overview.my.bucket.today": "Today",
  "overview.my.bucket.week": "This week",
  "overview.my.bucket.later": "Later",
  "overview.my.more": "Show {n} more",
  "overview.my.show": "Show",
  "overview.my.collapse": "Collapse",
  "overview.my.bugs.title": "My bugs",
  "overview.my.bugs.viewAll": "View all",
  "overview.my.bugs.empty": "No open bugs assigned to you",
  "overview.my.bugs.age": "{n}d ago",
  "overview.my.projects.title": "My projects",
  "overview.my.milestones.title": "Upcoming milestones",

  // PM calendar (personal / org-wide month view)
  "calendar.title": "Calendar",
  "calendar.subtitle": "See what's due today and this week",
  "calendar.view.all": "All",
  "calendar.view.member": "Mine",
  "calendar.notMember": "This account isn't a PM member yet",
  "calendar.empty": "No tasks in this range",
  "calendar.today": "Today",
  "calendar.filter.all": "All",
  "calendar.filter.task": "Tasks",
  "calendar.filter.event": "Events",
  "calendar.fullscreen": "Fullscreen",
  "calendar.fullscreenExit": "Exit fullscreen",

  // Events / meetings (embedded in calendar)
  "event.legend": "Event types",
  "event.type.meeting": "Meeting",
  "event.type.review": "Review",
  "event.type.milestone": "Milestone",
  "event.type.deadline": "Deadline",
  "event.type.other": "Other",
  "event.new": "New event",
  "event.edit": "Edit event",
  "event.field.title": "Title",
  "event.field.type": "Type",
  "event.field.start": "Start",
  "event.field.end": "End",
  "event.field.allDay": "All day",
  "event.field.project": "Project",
  "event.field.task": "Linked task",
  "event.field.attendees": "Attendees",
  "event.field.location": "Location",
  "event.field.note": "Note",
  "event.field.projectGlobal": "Global (no project)",
  "event.save": "Save",
  "event.cancel": "Cancel",
  "event.delete": "Delete",
  "event.deleteConfirm": "Delete this event?",
  "event.saved": "Saved",
  "event.deleted": "Deleted",
  "event.validate.title": "Please enter a title",
  "event.validate.time": "Please pick a start time",
  "event.validate.endBeforeStart": "End time cannot be earlier than start time",

  // PM projects
  "projects.title": "Projects",
  "projects.subtitle":
    "Organize projects by customer / product and track each one's progress",
  "projects.create": "Create Project",
  "projects.count": "{count} projects",
  "projects.searchPlaceholder": "Search projects…",
  "projects.filter.all": "All",
  "projects.filter.placeholder": "Filter by name or description",
  "projects.filter.emptyKw": "No project under this customer matches \"{kw}\"",
  "projects.filter.bridge": "Search tasks and bugs for \"{kw}\"",
  "projects.status.all": "All statuses",
  "projects.status.planned": "Not started",
  "projects.status.active": "In progress",
  "projects.status.paused": "Paused",
  "projects.status.done": "Delivered",
  "projects.selectCustomerFirst":
    "Select a customer / product on the left first",
  "projects.noMatch": "No matching projects",
  "projects.emptyHint":
    'This customer has no projects yet. Click "Create Project" to start',
  "projects.card.edit": "Edit project",
  "projects.card.delete": "Delete project",
  "projects.card.noDesc": "No description",
  "projects.card.enter": "Open",
  "projects.card.overdue": "Overdue",
  "projects.col.progress": "Progress",
  "projects.col.actions": "Actions",
  "projects.reordered": "Order updated",
  "projects.drag.hint": "Drag to reorder",
  "projects.drag.disabled": "Clear search / filter to drag-reorder",
  "projects.customers.title": "Customers / Products",
  "projects.customers.new": "Add customer / product",
  "projects.customers.searchPlaceholder": "Search customers…",
  "projects.customers.empty": "No customers",
  "projects.customers.count": "{count} projects",
  "projects.customers.avg": "progress {avg}%",
  "projects.customers.collapse": "Collapse list",
  "projects.customers.expand": "Expand list",
  "projects.delete.title": "Delete project",
  "projects.delete.content":
    'Delete "{customer} {name}"? All tasks and dependencies under this project will also be deleted and cannot be recovered.',
  "projects.delete.ok": "Delete",
  "projects.deleted": "Project deleted",
  "projects.form.createTitle": "Create Project",
  "projects.form.editTitle": "Edit Project",
  "projects.form.create": "Create",
  "projects.form.save": "Save",
  "projects.form.customer": "Customer / Product",
  "projects.form.customerRequired": "Please select a customer",
  "projects.form.customerPlaceholder": "Select customer",
  "projects.form.name": "Project name",
  "projects.form.nameRequired": "Enter a project name, e.g. v1.0.0",
  "projects.form.namePlaceholder": "v1.0.0",
  "projects.form.description": "Description",
  "projects.form.descriptionPlaceholder": "Main scope of this iteration…",
  "projects.form.status": "Status",
  "projects.form.statusRequired": "Please select a status",
  // ===== Kind (regular project / maintenance) =====
  "projects.form.kind": "Kind",
  "projects.form.kindRequired": "Please select a kind",
  "projects.form.kindTip":
    "Maintenance work takes requests continuously, so it is tracked by ticket count rather than completion rate",
  "projects.kind.project": "Regular project",
  "projects.kind.projectDesc": "Fixed scope, tracked by progress rate",
  "projects.kind.ops": "Maintenance",
  "projects.kind.opsDesc": "Ongoing work with requests arriving over time",
  "projects.form.endRequired": "Please select an end date",
  "projects.form.endOptional": "Leave empty to mark it as ongoing",
  "projects.form.startPlaceholder": "Start date",
  "projects.form.endPlaceholder": "End date",
  "projects.form.endOngoing": "Ongoing (open-ended)",
  "projects.card.ongoing": "Ongoing",
  "projects.ops.thisMonth": "{done}/{total} done this month",
  "projects.ops.open": "{count} open",
  // ===== Monthly effort quota (the "N person-days per month" in support contracts) =====
  "projects.form.quota": "Monthly quota",
  "projects.form.quotaTip":
    "The person-days per month in the support contract. Setting it shows this month's usage in the list",
  "projects.form.quotaOptional": "Leave empty for no quota (counts only)",
  "projects.form.quotaUnit": "person-days / mo",
  "projects.form.quotaPlaceholder": "e.g. 20",
  "projects.ops.quotaActual": "Actual {used} / {quota}",
  "projects.ops.quotaPlanned": "Planned {used} / {quota}",
  "projects.ops.quotaOver": "Over quota",
  "projects.ops.quotaTooltip": "This month — planned {planned} · actual {actual} · quota {quota}",
  "projects.form.range": "Date range",
  "projects.form.rangeRequired": "Please select a date range",
  "projects.updated": "Project updated",
  "projects.created": "Project created",
  "projects.cancel": "Cancel",
  "projects.customer.created": "Customer created",
  "projects.customer.createTitle": "Add customer / product",
  "projects.customer.name": "Name (customer / product)",
  "projects.customer.nameRequired": "Enter a name, e.g. Toho Bank",
  "projects.customer.namePlaceholder": "e.g. Toho Bank / Inventory App",
  "projects.customer.shortName": "Short name",
  "projects.customer.shortNamePlaceholder": "Optional, e.g. Toho",
  "projects.customer.team": "Team",
  "projects.customer.teamRequired": "Please select a team",
  "projects.customer.teamPlaceholder": "Select a team",
  "projects.customer.create": "Create",
  // ===== Gantt page tabs =====
  "projects.gantt.tab.wbs": "Detailed WBS",
  "projects.gantt.tab.board": "Board",
  "projects.gantt.tab.roadmap": "Rollout Schedule",
  "projects.gantt.tab.design": "Design board",
  // ===== Board (Kanban) view =====
  "projects.board.status.backlog": "Backlog",
  "projects.board.status.todo": "Todo",
  "projects.board.status.inProgress": "In Progress",
  "projects.board.status.testing": "Testing",
  "projects.board.status.done": "Done",
  "projects.board.status.cancelled": "Cancelled",
  "projects.board.empty": "No tasks to show on the board",
  // ===== Right pane: view switch / annual schedule =====
  "projects.view.list": "Versions",
  "projects.view.annual": "Annual Schedule",
  "projects.annual.newVersion": "New Version",
  "projects.annual.empty": "No versions in {year}",
  "projects.annual.release": "Release",
  "projects.annual.today": "Today",
  // ===== Gantt: WBS headers / row actions / toolbar =====
  "projects.gantt.col.name": "Task",
  "projects.gantt.col.start": "Start",
  "projects.gantt.col.duration": "Duration",
  "projects.gantt.col.progress": "Progress",
  "projects.gantt.col.people": "Assignees",
  "projects.gantt.row.addChild": "Add subtask",
  "projects.gantt.row.edit": "Edit",
  "projects.gantt.row.delete": "Delete",
  "projects.gantt.scale.day": "Day",
  "projects.gantt.scale.week": "Week",
  "projects.gantt.expandAll": "Expand all",
  "projects.gantt.collapseAll": "Collapse all",
  "projects.gantt.expandAllShort": "Expand",
  "projects.gantt.collapseAllShort": "Collapse",
  "projects.gantt.addTask": "Add task",
  "projects.gantt.empty.desc":
    'No tasks yet. Click "Add task" to start scheduling.',
  "projects.gantt.notFound": "Project not found",
  "projects.gantt.deleteTask.title": 'Delete "{name}"?',
  "projects.gantt.deleteTask.summary":
    "All subtasks under this task and their dependencies will also be deleted.",
  "projects.gantt.deleteTask.leaf":
    "Related dependency links will also be deleted.",
  // ===== Roadmap view =====
  // dayjs 月份格式（时间轴表头）
  "projects.roadmap.monthFormat": "MMM",
  "projects.roadmap.empty": "No items to show on the roadmap",
  "projects.roadmap.lane.milestone": "Milestone",
  "projects.roadmap.lane.system": "System",
  "projects.roadmap.lane.business": "Business",
  "projects.roadmap.lane.default": "Other",
  "projects.roadmap.party.client": "Client work",
  "projects.roadmap.party.vendor": "Vendor work",
  "projects.roadmap.legend.client": "Client work",
  "projects.roadmap.legend.vendor": "Vendor work",
  "projects.roadmap.msColor.critical": "Critical (red)",
  "projects.roadmap.msColor.normal": "Normal (gray)",
  "projects.roadmap.msColor.client": "Client (green)",
  "projects.roadmap.msColor.vendor": "Vendor (blue)",
  "projects.roadmap.optionManager.entry": "Lanes",
  "projects.roadmap.optionManager.title": "Manage lanes & milestone colors",
  "projects.roadmap.optionManager.teamHint": "Changes apply to the whole team",
  "projects.roadmap.optionManager.laneSection": "Lanes",
  "projects.roadmap.optionManager.msColorSection": "Milestone colors",
  "projects.roadmap.optionManager.addLane": "Add lane",
  "projects.roadmap.optionManager.addMsColor": "Add color",
  "projects.roadmap.optionManager.namePlaceholder": "Name",
  "projects.roadmap.optionManager.system": "Built-in",
  "projects.roadmap.optionManager.deleteConfirm": "Delete?",
  "projects.roadmap.optionManager.nameRequired": "Name is required",
  // ===== Task form: basic info =====
  "projects.taskForm.title.add": "Add Task",
  "projects.taskForm.title.edit": "Edit Task",
  "projects.taskForm.title.child": 'Add a subtask under "{name}"',
  "projects.taskForm.name": "Task name",
  "projects.taskForm.nameRequired": "Please enter a task name",
  "projects.taskForm.namePlaceholder": "e.g. Detailed Design_S0390_Screen",
  "projects.taskForm.type": "Type",
  "projects.taskForm.type.task": "Task",
  "projects.taskForm.type.summary": "Summary (phase)",
  "projects.taskForm.type.milestone": "Milestone",
  "projects.taskForm.project": "Project (phase)",
  "projects.taskForm.projectHint":
    "Switching to another project moves this task and all its subtasks together; dependency links that cross projects are removed.",
  "projects.taskForm.projectPlaceholder": "Select project",
  "projects.taskForm.parent": "Parent task (phase)",
  "projects.taskForm.parentHint":
    "Place this task under a summary (phase) in the selected project; leave empty for top level.",
  "projects.taskForm.parentRoot": "Top level (no phase)",
  "projects.taskForm.derivedHint":
    "A summary (phase)'s dates and progress are rolled up from its child tasks and can't be edited directly. Edit the child tasks instead.",
  "projects.taskForm.summaryRangeOptionalHint":
    "Optional: dates roll up automatically once child tasks are added; while empty, the project's period is used as a placeholder.",
  "projects.taskForm.milestoneDate": "Planned milestone date",
  "projects.taskForm.planRange": "Planned period",
  "projects.taskForm.rangeRequired": "Please select the planned period",
  "projects.taskForm.rangeOutOfProject":
    "The planned period must stay within the project period ({start} – {end})",
  "projects.taskForm.actualRange":
    "Actual period (blank if not started; start only = in progress)",
  "projects.taskForm.actualStartRequired":
    "A start date is required when an end date is set",
  "projects.taskForm.actualEndBeforeStart":
    "Actual end date cannot be before the start date",
  "projects.taskForm.effort": "Duration (days + hours)",
  "projects.taskForm.effortPlan": "Planned duration (days + hours)",
  "projects.taskForm.effortActual": "Actual duration (days + hours)",
  "projects.taskForm.effortTip":
    "Enter duration directly as days d + hours h (0–23.75, decimals allowed in 0.25 steps). Leave blank to auto-derive from the period (workdays × hours per day). Click [Use] below to apply a suggested value.",
  "projects.taskForm.effortSuffix": "h",
  "projects.taskForm.effortDaysSuffix": "d",
  "projects.taskForm.effortUse": "Use",
  "projects.taskForm.effortHint":
    "{days}d ({days} workdays ≈ {hours}h | 1d = {hpd}h)",
  "projects.taskForm.effortManualBadge": "Manual",
  "projects.taskForm.effortAutoBadge": "Auto from period ({dur})",
  "projects.taskForm.levels": "Labels (multiple, press Enter to add)",
  "projects.taskForm.levelsPlaceholder":
    "Type a label and press Enter, e.g. Important / Hard / Frontend",
  "projects.taskForm.progress": "Progress",
  "projects.taskForm.status": "Status",
  "projects.taskForm.assignee": "Assignees",
  "projects.taskForm.assigneePlaceholder": "Select members",
  "projects.taskForm.description": "Description (images supported)",
  "projects.taskForm.descriptionPlaceholder":
    "Enter a task description; paste or drag & drop screenshots…",
  // ===== Task comments =====
  "projects.comments.title": "Comments",
  "projects.comments.empty": "No comments yet",
  "projects.comments.placeholder": "Write a comment (⌘/Ctrl+Enter to send)",
  "projects.comments.send": "Send",
  "projects.comments.emoji": "Emoji",
  "projects.comments.edited": "edited",
  "projects.comments.deleteConfirm": "Delete this comment?",
  // ===== Task form: linked references (design / Figma) =====
  // ===== Task activity log (drawer right column, "Activity" tab) =====
  "projects.activity.title": "Activity",
  "projects.activity.empty": "No activity yet",
  "projects.activity.emptyHint": "Edits to this task are recorded automatically",
  "projects.activity.noneInFilter": "No activity matches this filter",
  "projects.activity.today": "Today",
  "projects.activity.none": "Not set",
  "projects.activity.ongoing": "Open",
  "projects.activity.autoEffort": "Auto from dates",
  "projects.activity.showFull": "Show full text",
  "projects.activity.collapse": "Collapse",
  "projects.activity.filter.all": "All activity",
  "projects.activity.filter.progress": "Status & progress",
  "projects.activity.filter.schedule": "Dates & effort",
  "projects.activity.filter.people": "Assignees & labels",
  "projects.activity.filter.other": "Description & other",
  "projects.activity.action.created": "created this task",
  "projects.activity.action.updated": "changed {count} fields",
  "projects.activity.action.updatedOne": "changed {field}",
  "projects.activity.action.childAdded": "added a subtask",
  "projects.activity.action.childRemoved": "removed a subtask",
  "projects.activity.action.depAdded": "added a dependency",
  "projects.activity.action.depRemoved": "removed a dependency",
  "projects.activity.field.name": "Name",
  "projects.activity.field.type": "Type",
  "projects.activity.field.status": "Status",
  "projects.activity.field.progress": "Progress",
  "projects.activity.field.planRange": "Planned dates",
  "projects.activity.field.actualRange": "Actual dates",
  "projects.activity.field.plannedEffort": "Planned effort",
  "projects.activity.field.actualEffort": "Actual effort",
  "projects.activity.field.assignees": "Assignees",
  "projects.activity.field.levels": "Labels",
  "projects.activity.field.description": "Description",
  "projects.activity.field.parent": "Parent task",
  "projects.activity.field.project": "Project",
  "projects.activity.field.roadmapVisible": "Roadmap",
  "projects.activity.field.roadmapLane": "Lane",
  "projects.activity.field.ownerParty": "Owner",
  "projects.activity.field.milestoneColor": "Milestone color",
  "projects.activity.field.subtask": "Subtask",
  "projects.activity.field.predecessor": "Predecessor",
  "projects.activity.field.successor": "Successor",
  "projects.activity.value.shown": "Shown",
  "projects.activity.value.hidden": "Hidden",
  "projects.links.title": "Design",
  "projects.links.empty": "No design links yet",
  "projects.links.urlPlaceholder": "Paste a Figma link (or any URL)",
  "projects.links.titlePlaceholder": 'Label (optional, e.g. "Login v2")',
  "projects.links.add": "Add",
  "projects.links.figmaHint":
    'Figma must be set to "Anyone with the link can view" to preview inline',
  "projects.links.open": "Open in new tab",
  "projects.links.deleteConfirm": "Remove this link?",
  // ===== Task form: roadmap settings =====
  "projects.taskForm.roadmap.panel": "Roadmap settings",
  "projects.taskForm.roadmap.visible": "Show on roadmap",
  "projects.taskForm.roadmap.lane": "Lane",
  "projects.taskForm.roadmap.lanePlaceholder": "Select a lane",
  "projects.taskForm.roadmap.ownerParty": "Owner",
  "projects.taskForm.roadmap.milestoneColor": "Milestone color",
  "projects.taskForm.roadmap.milestoneColorPlaceholder": "Select a color",

  // ===== Resources (member) view =====
  "resources.title": "Resources",
  "resources.subtitle":
    "See each member's tasks across projects and spot scheduling overlaps / overload",
  "resources.mode.single": "Single",
  "resources.mode.all": "All members",
  "resources.scale.day": "Day",
  "resources.scale.week": "Week",
  "resources.year.auto": "Auto",
  "resources.range.start": "Start month",
  "resources.range.end": "End month",
  "resources.hideCompleted": "Hide completed tasks",
  "resources.member.placeholder": "Select a member",
  "resources.member.empty": "No members",
  "resources.selectMemberFirst": "Select a member first",
  "resources.empty": "No tasks for this member",
  "resources.allEmpty": "No assigned tasks",
  "resources.loading": "Loading…",
  "resources.view.timeline": "Timeline",
  "resources.view.list": "List",
  "resources.list.total": "{n} total",
  "resources.col.task": "Task",
  "resources.col.project": "Project",
  "resources.col.assignee": "Assignee",
  "resources.col.plan": "Planned",
  "resources.col.actual": "Actual",
  "resources.col.progress": "Progress",
  "resources.conflict.badge": "Overlap",
  "resources.conflict.tip":
    "{count} tasks overlap in time (working on multiple projects at once)",
  "resources.conflict.legend": "Schedule overlap / overload",
  "resources.noSchedule": "(no schedule)",
  "resources.backToAll": "Back to all members",
  "resources.openDetail": "View this member's detail",
  "resources.editTask": "Edit task",

  // ===== Work-hour actuals summary (single mode) =====
  "resources.stats.title": "Work-hour Summary",
  "resources.stats.note": "Includes completed",
  "resources.stats.hpd": "1 workday = {hpd}h",
  "resources.stats.hint":
    "Aggregated per assignee (involvement basis): a multi-assignee task counts its full effort for each assignee, so cross-member sums double-count. Effort uses 1 working day = {hpd}h.",
  "resources.stats.collapse": "Collapse",
  "resources.stats.expand": "Expand",
  "resources.stats.empty": "No assigned tasks in this period",
  "resources.stats.kpi.actual": "Total Actual",
  "resources.stats.kpi.planned": "Total Planned",
  "resources.stats.kpi.tasks": "Active Tasks",
  "resources.stats.kpi.rate": "Consumption",
  "resources.stats.kpi.unit": "",
  "resources.stats.kpi.target": "{n} tasks",
  "resources.stats.kpi.done": "Done {n}",
  "resources.stats.kpi.wip": "WIP {n}",
  "resources.stats.kpi.remain": "Left {v}",
  "resources.stats.kpi.over": "Over {v}",
  "resources.stats.kpi.noPlan": "No plan",
  "resources.stats.kpi.noPlanShort": "No plan",
  "resources.stats.kpi.rateHint": "Actual / Planned",
  "resources.stats.export.btn": "Export Excel",
  "resources.stats.export.sheet1": "Summary",
  "resources.stats.export.sheet2": "Task List",
  "resources.stats.export.member": "Member",
  "resources.stats.export.period": "Period",
  "resources.stats.export.allPeriod": "All",
  "resources.stats.export.metric": "Metric",
  "resources.stats.export.value": "Value",
  "resources.stats.export.delta": "Plan diff",
  "resources.stats.export.doneLabel": "Completed tasks",
  "resources.stats.export.wipLabel": "In-progress tasks",
  "resources.stats.export.col.name": "Task",
  "resources.stats.export.col.customer": "Customer",
  "resources.stats.export.col.status": "Status",
  "resources.stats.export.col.planStart": "Plan Start",
  "resources.stats.export.col.planEnd": "Plan End",
  "resources.stats.export.col.actualStart": "Actual Start",
  "resources.stats.export.col.actualEnd": "Actual End",
  "resources.stats.export.status.done": "Done",
  "resources.stats.export.status.ongoing": "Started",
  "resources.stats.export.status.wip": "In progress",
  "resources.stats.export.status.todo": "Not started",

  // ===== PM Customers / Products page =====
  "customers.title": "Customers / Products",
  "customers.subtitle":
    "Manage customers and products as the owner of projects",
  "customers.new": "New customer",
  "customers.create": "Create",
  "customers.search.placeholder": "Search name / short name…",
  "customers.count": "{count} customers / products",
  "customers.col.name": "Name",
  "customers.col.shortName": "Short name",
  "customers.col.projectCount": "Projects",
  "customers.col.createdAt": "Created",
  "customers.empty": "No customers yet. Click “New customer” to add one",
  "customers.edit": "Edit customer",
  "customers.delete.title": "Delete “{name}”?",
  "customers.delete.hasProjects":
    "This customer still has {count} project(s); they will lose their owner after deletion.",
  "customers.delete.irreversible": "This action cannot be undone.",
  "customers.msg.saved": "Saved",
  "customers.msg.created": "Customer created",
  "customers.form.name": "Name (customer / product)",
  "customers.form.name.required": "Please enter a name, e.g. Toho Bank",
  "customers.form.name.placeholder": "e.g. Toho Bank / Inventory App",
  "customers.form.shortName": "Short name",
  "customers.form.shortName.placeholder": "Optional, e.g. Toho / Sales",
  "customers.col.status": "Status",
  "customers.status.active": "Active",
  "customers.status.inactive": "Inactive",
  "customers.form.active": "Status",
  "customers.form.active.tip":
    "When inactive, this customer is treated as archived",

  // ===== PM rich text editor =====
  "pm.rte.uploading": "Uploading image…",
  "pm.rte.uploadFailed": "Image upload failed",
  "pm.rte.bold": "Bold",
  "pm.rte.italic": "Italic",
  "pm.rte.underline": "Underline",
  "pm.rte.strike": "Strikethrough",
  "pm.rte.bulletList": "Bulleted list",
  "pm.rte.orderedList": "Numbered list",
  "pm.rte.alignLeft": "Align left",
  "pm.rte.alignCenter": "Align center",
  "pm.rte.alignRight": "Align right",
  "pm.rte.insertImage": "Insert image",
  "pm.rte.imgSmall": "Image: small",
  "pm.rte.imgMedium": "Image: medium",
  "pm.rte.imgFull": "Image: full width",
  "pm.rte.hint": "Paste or drag images directly",
  "pm.rte.placeholder": "Enter task description, images can be pasted…",

  // ===== PM Gantt · actual =====
  "gantt.actual.ongoing": "Actual {start}~ in progress (not finished)",
  "gantt.actual.range": "Actual {start}~{end} ({dur})",
  "gantt.tip.planEffort": "Planned effort",
  "gantt.tip.actualEffort": "Actual effort",
  "gantt.foot.total": "Total",
  "gantt.foot.planned": "Plan",
  "gantt.foot.actual": "Actual",
  "gantt.foot.note": "* Calculated as 1 day = {hpd} hours",

  // ===== PM Mind Map =====
  "mindmap.title": "Mind Maps",
  "mindmap.empty": "No mind maps yet — create one to get started",
  "mindmap.noProject": "No project",
  "mindmap.updatedAt": "Updated {time}",
  "mindmap.notFound": "Mind map not found or deleted",
  "mindmap.act.new": "New map",
  "mindmap.act.editInfo": "Edit info",
  "mindmap.act.delete": "Delete",
  "mindmap.act.back": "Back",
  "mindmap.act.addChild": "Add child (Tab)",
  "mindmap.act.addSibling": "Add sibling (Enter)",
  "mindmap.act.nodeColor": "Node color",
  "mindmap.act.collapseAll": "Collapse all",
  "mindmap.act.expandAll": "Expand all",
  "mindmap.act.zoomIn": "Zoom in",
  "mindmap.act.zoomOut": "Zoom out",
  "mindmap.act.fit": "Fit to screen",
  "mindmap.act.exportPng": "Export PNG",
  "mindmap.act.reload": "Reload",
  "mindmap.field.name": "Name",
  "mindmap.field.nameRequired": "Please enter a name",
  "mindmap.field.namePlaceholder": "e.g. Product planning map",
  "mindmap.field.project": "Linked project (optional)",
  "mindmap.field.projectPlaceholder": "Select a project",
  "mindmap.msg.created": "Created",
  "mindmap.msg.updated": "Updated",
  "mindmap.msg.deleted": "Deleted",
  "mindmap.msg.confirmDelete": 'Delete "{name}"?',
  "mindmap.save.saved": "Saved",
  "mindmap.save.dirty": "Unsaved…",
  "mindmap.save.saving": "Saving…",
  "mindmap.save.error": "Save failed",
  "mindmap.save.conflict": "Updated elsewhere",
  "mindmap.theme.classic": "Classic",
  "mindmap.theme.dark": "Dark",
  "mindmap.theme.forest": "Forest",
  "mindmap.theme.sunset": "Sunset",
  "mindmap.tip.rootUndeletable": "The central topic can't be deleted",
  "mindmap.hint.keys":
    "Tab child · Enter sibling · Double-click to rename · Delete to remove · Ctrl/⌘+wheel to zoom",

  // Holidays management
  "pages.holidays.title": "Holidays",
  "pages.holidays.teamHint":
    "Holidays are tenant-wide; changes affect the whole team. Duration and progress now exclude weekends and these holidays.",
  "pages.holidays.syncNow": "Sync now",
  "pages.holidays.syncSuccess":
    "Synced: {added} added, {updated} updated, {removed} removed",
  "pages.holidays.add": "Add",
  "pages.holidays.import": "Import",
  "pages.holidays.yearAll": "All years",
  "pages.holidays.col.date": "Date",
  "pages.holidays.col.name": "Name",
  "pages.holidays.col.source": "Source",
  "pages.holidays.col.action": "Action",
  "pages.holidays.source.manual": "Manual",
  "pages.holidays.source.synced": "Synced",
  "pages.holidays.edit": "Edit",
  "pages.holidays.delete": "Delete",
  "pages.holidays.deleteConfirm": "Delete this holiday?",
  "pages.holidays.empty":
    'No holidays yet. Click "Sync now" to fetch from holidays-jp, or add manually.',
  "pages.holidays.saved": "Saved",
  "pages.holidays.addTitle": "Add holiday",
  "pages.holidays.editTitle": "Edit holiday",
  "pages.holidays.form.date": "Date",
  "pages.holidays.form.dateRequired": "Please pick a date",
  "pages.holidays.form.name": "Name",
  "pages.holidays.form.nameRequired": "Please enter a name",
  "pages.holidays.form.namePlaceholder": "e.g. New Year's Day",
  "pages.holidays.importTitle": "Import holidays",
  "pages.holidays.importHint":
    "One per line: YYYY-MM-DD Name (comma / tab / space separated). Existing dates are skipped.",
  "pages.holidays.importEmpty": "No valid rows to import",
  "pages.holidays.importResult": "Imported {added}",

  // ===== 品質管理（Quality）=====
  "quality.title": "Quality",
  "quality.subtitle": "Manage test cases, record execution, and track bugs",
  "quality.selectProject": "Select project",
  "quality.noProject": "No projects to show",
  "quality.tab.cases": "Test Cases",
  "quality.tab.bugs": "Bugs",
  "quality.suite.title": "Suites",
  "quality.suite.all": "All",
  "quality.suite.add": "Add suite",
  "quality.suite.edit": "Edit suite",
  "quality.suite.name": "Suite name",
  "quality.suite.prefix": "ID prefix (e.g. STU)",
  "quality.suite.description": "Description",
  "quality.suite.deleteConfirm": "Delete this suite and its cases?",
  "quality.suite.empty": 'No suites yet. Click "Add suite" to create one.',
  "quality.category.normal": "Normal",
  "quality.category.abnormal": "Abnormal",
  "quality.category.boundary": "Boundary",
  "quality.result.pass": "Pass",
  "quality.result.fail": "Fail",
  "quality.result.na": "N/A",
  "quality.result.untested": "Untested",
  "quality.priority.high": "High",
  "quality.priority.medium": "Medium",
  "quality.priority.low": "Low",
  "quality.severity.high": "High",
  "quality.severity.medium": "Medium",
  "quality.severity.low": "Low",
  "quality.bugStatus.open": "Open",
  "quality.bugStatus.inProgress": "In progress",
  "quality.bugStatus.resolved": "Resolved",
  "quality.bugStatus.verifying": "Verifying",
  "quality.bugStatus.closed": "Closed",
  "quality.bugStatus.wontfix": "Won't fix",
  "quality.case.no": "ID",
  "quality.case.title": "Viewpoint",
  "quality.case.feature": "Feature",
  "quality.case.category": "Type",
  "quality.case.priority": "Priority",
  "quality.case.result": "Result",
  "quality.case.assignee": "Tester",
  "quality.case.task": "Task",
  "quality.case.actions": "Actions",
  "quality.case.add": "Add case",
  "quality.case.edit": "Edit case",
  "quality.case.deleteConfirm": "Delete this case?",
  "quality.case.precondition": "Precondition",
  "quality.case.steps": "Steps",
  "quality.case.testData": "Test data",
  "quality.case.expected": "Expected",
  "quality.case.remark": "Remark",
  "quality.case.raiseBug": "Raise bug",
  "quality.case.batchResult": "Bulk set result",
  "quality.case.selectedN": "{n} selected",
  "quality.case.searchPlaceholder": "Search viewpoint / feature / ID",
  "quality.case.filterResult": "Result",
  "quality.case.filterCategory": "Type",
  "quality.case.filterPriority": "Priority",
  "quality.case.filterAssignee": "Tester",
  "quality.case.filterFeature": "Feature",
  "quality.case.empty": "No cases",
  "quality.case.linkTask": "Link task",
  "quality.suite.linkTask": "Link task (optional)",
  "quality.case.unlinkTask": "Unlink",
  "quality.case.notLinked": "Not linked",
  "quality.bug.no": "ID",
  "quality.bug.title": "Title",
  "quality.bug.severity": "Severity",
  "quality.bug.priority": "Priority",
  "quality.bug.status": "Status",
  "quality.bug.assignee": "Assignee",
  "quality.bug.reporter": "Reporter",
  "quality.bug.task": "Task",
  "quality.bug.noTask": "No matching task",
  "quality.bug.noDescription": "No description provided.",
  "quality.bug.batchLinkN": "Link {n} selected to a task",
  "quality.bug.batchLinkedN": "Linked {n} bug(s)",
  "quality.bug.batchUnlink": "Unlink task",
  "quality.bug.batchUnlinkConfirm": "Unlink the task from {n} selected bug(s)?",
  "quality.bug.linkExisting": "Link existing bugs",
  "quality.bug.linkExistingHint": "Select existing bugs to link to this task.",
  "quality.bug.selectBugs": "Select bugs",
  "quality.bug.project": "Product / Project",
  "quality.bug.wholeProduct": "(whole product)",
  "quality.bug.selectProduct": "Please select a product or project",
  "quality.bug.movedTo": 'Moved to "{product}" (renumbered)',
  "quality.bug.createdAt": "Reported at",
  "quality.bug.reportedOn": "Reported date",
  "quality.bug.resolvedAt": "Resolved date",
  "quality.bug.testCase": "From case",
  "quality.bug.actions": "Actions",
  "quality.bug.add": "Raise bug",
  "quality.bug.detail": "Detail",
  "quality.bug.edit": "Edit",
  "quality.bug.deleteConfirm": "Delete this bug?",
  "quality.bug.description": "Description (repro/expected/actual)",
  "quality.bug.environment": "Environment",
  "quality.bug.reopenCount": "Reopened {n}x",
  "quality.bug.filterStatus": "Status",
  "quality.bug.filterSeverity": "Severity",
  "quality.bug.filterPriority": "Priority",
  "quality.bug.filterAssignee": "Assignee",
  "quality.bug.reportedFrom": "Reported from",
  "quality.bug.reportedTo": "Reported to",
  "quality.bug.resolvedFrom": "Resolved from",
  "quality.bug.resolvedTo": "Resolved to",
  "quality.bug.empty": "No bugs",
  "quality.bug.fromCase": "From case {caseNo}",
  "quality.bug.tabCount": "Unresolved {active} / All {total}",
  "quality.bug.statusActive": "Unresolved",
  "quality.bug.overview.active": "Unresolved",
  "quality.bug.overview.highSeverity": "High severity",
  "quality.bug.overview.oldest": "Oldest unresolved",
  "quality.bug.overview.days": "d",
  "quality.bug.overview.thisWeek": "This week: +{reported} reported / {resolved} resolved",
  "quality.bug.searchPlaceholder": "Search ID, title, description",
  "quality.bug.filterProject": "Project",
  "quality.bug.wholeProductShort": "Whole product",
  "quality.bug.advancedFilter": "More filters",
  "quality.bug.filterTask": "Linked task",
  "quality.bug.taskLinked": "Linked",
  "quality.bug.taskUnlinked": "Not linked",
  "quality.bug.clearFilters": "Clear filters",
  "quality.bug.export": "Export",
  "quality.bug.settings": "Settings",
  "quality.bug.columns": "Columns",
  "quality.bug.ageDays": "{n}d old",
  "quality.bug.more": "More actions",
  "quality.bug.duplicate": "Duplicate",
  "quality.bug.copyLink": "Copy link",
  "quality.bug.linkCopied": "Link copied",
  "quality.bug.selectedN": "{n} selected",
  "quality.bug.batchStatus": "Change status",
  "quality.bug.batchAssignee": "Change assignee",
  "quality.bug.batchLink": "Link to task",
  "quality.bug.batchDeleteConfirm": "Delete {n} selected bugs?",
  "quality.bug.clearSelection": "Clear selection",
  "quality.bug.pageTotal": "{start}–{end} of {total}",
  "quality.bug.chip.reported": "Reported: {v}",
  "quality.bug.chip.resolved": "Resolved: {v}",
  "quality.bug.chip.task": "Linked task: {v}",
  "quality.bug.chip.reporter": "Reporter: {v}",
  "quality.bug.chip.environment": "Environment: {v}",
  "quality.bug.reopenCountHeader": "Reopen count",
  "quality.bug.resolvedAtHint": "Set automatically when the status becomes Resolved or Closed",
  "quality.common.undo": "Undo",
  "quality.msg.undone": "Undone",
  "quality.common.save": "Save",
  "quality.common.cancel": "Cancel",
  "quality.common.all": "All",
  "quality.common.unassigned": "Unassigned",
  "quality.common.openGantt": "Open in Gantt",
  "quality.common.delete": "Delete",
  "quality.common.add": "Add",
  "quality.common.close": "Close",
  "quality.common.actions": "Actions",
  "quality.env.manage": "Environments",
  "quality.env.select": "Select environment",
  "quality.env.empty": "No environments yet",
  "quality.env.emptyForProduct": "No environments for this product",
  "quality.env.name": "Label",
  "quality.env.browser": "Device/Browser",
  "quality.env.url": "URL",
  "quality.env.namePlaceholder": "dev / stg / prod",
  "quality.env.browserPlaceholder": "Chrome / iOS Safari",
  "quality.env.urlPlaceholder": "https://dev.example.jp",
  "quality.env.deleteConfirm": "Delete this environment?",
  "quality.msg.saved": "Saved",
  "quality.msg.deleted": "Deleted",
  "quality.msg.resultUpdated": "Result updated",
  "quality.msg.batchDone": "{n} updated",
  "quality.msg.bugRaised": "Bug {bugNo} created",
  "quality.msg.statusUpdated": "Status updated",
  "quality.msg.selectCases": "Select cases first",
  "quality.summary.execution": "Executed",
  "quality.task.openInQuality": "Open in Quality",

  // Cross-project task search (command palette, Cmd+K)
  "search.entry": "Search",
  "search.placeholder": "Search tasks, projects, bugs",
  "search.hint": "Search by task name, project, customer, or bug number",
  "search.empty": "Nothing matches \u201c{kw}\u201d",
  "search.kind.all": "All",
  "search.kind.task": "Tasks",
  "search.kind.project": "Projects",
  "search.kind.bug": "Bugs",
  "search.overdueDays": "{n}d overdue",
  "search.openTasks": "{n} open",
  "search.foot.move": "Move",
  "search.foot.open": "Open",
  "search.foot.openProject": "Open project",

  // Keyword filter inside WBS / board (cross-project search lives in the Cmd+K palette)
  "projects.gantt.filter.placeholder": "Filter by task name",
  "projects.gantt.filter.hits": "{n} found",
  "projects.gantt.filter.empty": "No task matches \u201c{kw}\u201d",
  "projects.gantt.filter.clear": "Clear filter",

  // 資料（外部ドライブのリンク：顧客 / 案件 / タスク）。設計 doc/design/pm-drive-docs.md
  "docs.title": "Docs",
  "docs.projectButton": "Project docs ({n})",
  "docs.add": "Add doc",
  "docs.linkToTask": "Link doc",
  "docs.open": "Open in new tab",
  "docs.empty": "No docs registered yet",
  "docs.filterEmpty": "No docs match the filter",
  "docs.unlinkedEmpty": "Every doc is linked to a task",
  "docs.taskEmpty": "No docs linked to this task",
  "docs.selectToPreview": "Select a doc to preview it here",
  "docs.deleteConfirm": "Remove “{name}” from PM?",
  "docs.deleteConfirm.desc": "The file in the drive is not deleted. Only its registration and task links in PM are removed.",
  "docs.remove": "Remove",
  "docs.unlinkConfirm": "Unlink this doc from the task?",
  "docs.unlink": "Unlink",
  "docs.linkTasks": "Link to tasks",
  "docs.linkTasks.title": "Linked tasks",
  "docs.linkTasks.note": "The selection replaces the current links. Leave it empty to unlink from all tasks.",
  "docs.common": "Customer-wide",
  "docs.projectWide": "Whole project",
  "docs.unlinked": "Unlinked",
  "docs.addedBy": "Added by {name}",
  "docs.group.project": "Project",
  "docs.provider.google": "Google Drive",
  "docs.provider.microsoft": "SharePoint",
  "docs.provider.box": "Box",
  "docs.provider.other": "Link",
  "docs.kind.gdoc": "Google Docs",
  "docs.kind.gsheet": "Google Sheets",
  "docs.kind.gslide": "Google Slides",
  "docs.kind.gfile": "File",
  "docs.kind.gfolder": "Folder",
  "docs.kind.ms": "Microsoft 365 file",
  "docs.kind.box": "Box file",
  "docs.kind.link": "External link",
  "docs.type.all": "All types",
  "docs.type.pdf": "PDF",
  "docs.type.xls": "Spreadsheet",
  "docs.type.doc": "Document",
  "docs.type.ppt": "Slides",
  "docs.type.img": "Image",
  "docs.type.folder": "Folder",
  "docs.type.file": "Other file",
  "docs.type.link": "Link",
  "docs.preview.hint": "Not showing? You may lack view permission, be signed in with another account, or your browser may be blocking embeds.",
  "docs.fallback.title": "This doc can’t be previewed here",
  "docs.fallback.google": "We couldn’t read a Google Drive file ID from this URL. Re-registering it with the file’s share link may enable the preview.",
  "docs.fallback.microsoft": "SharePoint / OneDrive docs are link-only for now. Open them in a new tab.",
  "docs.fallback.box": "Box docs are link-only for now. Open them in a new tab.",
  "docs.fallback.other": "This is a link to an external site. Open it in a new tab.",
  "docs.root.customer": "Customer root folder",
  "docs.root.project": "Project folder",
  "docs.root.unsetCustomer": "No customer root folder set",
  "docs.root.unsetProject": "No project folder set",
  "docs.root.unsetHint": "Set a Google Drive folder to browse its contents here",
  "docs.root.set": "Set folder",
  "docs.root.change": "Change",
  "docs.root.remove": "Unset",
  "docs.drawer.stats": "{projects} projects · {docs} docs",
  "docs.root.bannerHint": "Files stay in the customer's Drive. PM stores only links and their associations; access follows the Drive sharing settings.",
  "docs.root.openFolder": "Open root folder",
  "docs.root.removeConfirm": "Unset this folder?",
  "docs.view.registered": "Registered ({n})",
  "docs.view.unlinked": "Unlinked ({n})",
  "docs.folder.registerHint": "Register files in this folder via \"Add doc\" (top right) to preview them here and link them to tasks.",
  "docs.form.url.folder": "Folders cannot be registered as documents. Set it as the root (project) folder, or register the files inside it.",
  "docs.search.placeholder": "Search by name, URL or task",
  "docs.col.name": "Name",
  "docs.col.provider": "Storage",
  "docs.col.target": "Linked to",
  "docs.col.createdAt": "Added",
  "docs.drawer.customer": "Customer docs",
  "docs.drawer.project": "Project docs",
  "docs.form.addTitle": "Add doc",
  "docs.form.rootTitle": "Set folder",
  "docs.form.mode.new": "Register a URL",
  "docs.form.mode.existing": "Pick a registered doc",
  "docs.form.url": "Share link (URL)",
  "docs.form.url.placeholder": "Paste a share link from Google Drive, SharePoint, Box, etc.",
  "docs.form.url.rootPlaceholder": "Paste the share link of a Google Drive folder",
  "docs.form.url.extra": "Files stay in the drive. Access follows the drive’s sharing settings.",
  "docs.form.url.rootExtra": "Replaces the current folder, if any.",
  "docs.form.url.required": "Enter a URL",
  "docs.form.url.invalid": "Enter a URL starting with http:// or https:// (up to 2000 characters)",
  "docs.form.title": "Display name",
  "docs.form.title.placeholder": "Optional (file name or domain is shown if empty)",
  "docs.form.scope": "Link to",
  "docs.form.scope.task": "Tasks",
  "docs.form.project": "Project",
  "docs.form.project.required": "Select a project",
  "docs.form.tasks": "Tasks",
  "docs.form.tasks.placeholder": "Select tasks (search by WBS path)",
  "docs.form.tasks.required": "Select at least one task",
  "docs.form.existing": "Docs",
  "docs.form.existing.placeholder": "Select docs registered in this project",
  "docs.form.existing.required": "Select at least one doc",
  "docs.hint.preview": "Recognized as {kind} (preview available)",
  "docs.hint.linkOnly": "Will be saved as a {provider} link (no preview; opens in a new tab)",
  "docs.msg.added": "Doc added",
  "docs.msg.linked": "Linked",
  "docs.msg.removed": "Removed",
  // Google Picker（第二步）。設計 doc/design/pm-drive-docs.md §7
  "docs.msg.addedN": "Added {n} documents",
  "docs.emptyWithFolder": "Use \"Add doc\" (top right) to pick files from the root folder. Registered files can be previewed here and linked to tasks.",
  "docs.defaultName.folder.google": "Google Drive folder",
  "docs.defaultName.folder.microsoft": "SharePoint folder",
  "docs.defaultName.folder.box": "Box folder",
  "docs.defaultName.folder.other": "Shared folder",
  "docs.defaultName.gfile": "Google Drive file",
  "docs.chip.all": "All",
  "docs.chip.pdf": "PDF",
  "docs.chip.xls": "Excel",
  "docs.chip.doc": "Word",
  "docs.chip.ppt": "PowerPoint",
  "docs.chip.img": "Images",
  "docs.chip.folder": "Folders",
  "docs.form.mode.google": "Pick from Google Drive",
  "docs.form.mode.googleFolder": "Pick from Google Drive",
  "docs.picker.title": "Select documents to register in PM",
  "docs.picker.titleFolder": "Select a folder",
  "docs.picker.view.thisFolder": "This folder",
  "docs.picker.view.myDrive": "My Drive",
  "docs.picker.view.sharedDrives": "Shared drives",
  "docs.picker.disabled": "Google Drive integration is not configured",
  "docs.picker.disabled.desc": "Once an administrator configures Google Picker (API key and OAuth client), you can pick files directly from Drive. Until then, please use \"Register a URL\".",
  "docs.picker.pick": "Select files from Google Drive",
  "docs.picker.pickMore": "Select more",
  "docs.picker.pickFolder": "Select a folder from Google Drive",
  "docs.picker.repickFolder": "Choose a different folder",
  "docs.picker.removeItem": "Remove from selection",
  "docs.picker.note": "Pick a folder to add all the files inside it. Files stay in Drive, and access follows Drive sharing settings.",
  "docs.picker.required": "Select at least one file",
  "docs.picker.titleInFolder": "Select files in \"{name}\"",
  "docs.picker.expanded": "Added {n} files from \"{name}\"",
  "docs.picker.skipDup": "Skipped {n} already registered",
  "docs.picker.importFiles": "Also register the files in this folder",
  "docs.msg.rootImported": "Root folder set and {n} files registered",
  "docs.picker.addN": "Add {n}",
  "docs.picker.err.config": "Could not load the Google Drive settings. Please try again later.",
  "docs.picker.err.load": "Could not load Google's scripts. Check your network connection and any ad or tracking blocker extensions.",
  "docs.picker.err.popup": "Could not open the Google sign-in window. Allow pop-ups for this site and try again.",
  "docs.picker.err.auth": "Google authorization failed. Please try again later or contact your administrator.",
  "docs.picker.err.scope": "Drive access was not granted. Please check the Google Drive option on the consent screen.",
};
